import { useState } from "react";
import { TypedFilter } from "odata-query";
import { taskService } from "@miplatform/api";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IInspectionAttempt } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getInspectionsUUID = createUUID();

export const useInspectionAttempts = ({
  debouncedSearch = "",
}: IUseInspectionsProps = {}) => {
  const stateManager = useComponentState();

  const [inspections, setInspections] = useState<IInspectionAttempt[]>([]);
  const [filter, setFilter] = useState<TypedFilter<IInspectionAttempt>>({});

  const getInspections = async ({
    top,
    skip,
    sort,
    filters = {},
    params,
    signal,
  }: IApiRequest<IInspectionAttempt> = {}) => {
    stateManager.abort(getInspectionsUUID);

    const searchFilter = debouncedSearch
      ? { name: { contains: debouncedSearch } }
      : {};

    const combinedFilters = {
      ...filter,
      ...filters,
      ...searchFilter,
    };

    return stateManager.run(async () => {
      return taskService.inspection.getAllAttempts({
        sort,
        top,
        skip,
        filters: combinedFilters,
        ...params,
        signal,
      });
    }, getInspectionsUUID);
  };

  return {
    inspections,
    getInspections,
    setInspections,
    filter,
    setFilter,
    loading: stateManager.isBusy(),
  };
};

interface IUseInspectionsProps {
  debouncedSearch?: string;
}
